<template>
  <div>
    <div class="box" v-if='fillingDeta.subjectType === 0'>
      <el-row>
        <el-col :span="3" style="overflow: hidden;">
          <div class="box-t-l">
            <p>文件列表</p>
            <ul class="ull">
              <li v-for='(m, index) in fillingDeta.plandoc' :key="index" @click="getfile(m,index)" :class='{activess:activeli === index}'>
                <span slot="label" :title="formatPlanDoc(m.type)">{{formatPlanDoc(m.type)}}</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="box-pdf box-t-r">
            <pdf :src="srcaddress" :activeData="activeData" :canReupload="false"></pdf>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="box-t-rb">
            <el-tabs v-model="activeName2" type="card">
              <!-- <el-tab-pane label="备案信息" name="first">
                <p class="title">
                  <span>备案流水号： {{fillingDeta.serialCode}}</span>
                </p>
              </el-tab-pane> -->
              <el-tab-pane label="申报单位信息" name="second">
                <p>
                  <span>企业全称：</span>
                  <span>{{fillingDeta.subjectName}}</span>
                </p>
                <p>
                  <span>中心坐标：</span>
                  <span>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</span>
                </p>
                <p>
                  <span>统一社会信用代码：</span>
                  <span>{{fillingDeta.code}}</span>
                </p>
                <p>
                  <span>行业：</span>
                  <span>{{ChangeName(fillingDeta.industry)}}</span>
                </p>
                <p class="flex flex-vc flex-hs">
                  <span>营业执照：</span>
                  <!-- <span @click="previewImg(fillingDeta.imgName)" class="a-hover">查看</span> -->
                  <!-- 查看查看 -->
                  <viewer :images="photo" class="seeBigImg">
                    <img
                      v-for="(src,index) in photo"
                      :src="src"
                      :key="index"
                    >
                  </viewer>
                </p>
                <p>
                  <span>企业法人：</span>
                  <span>{{fillingDeta.legalPerson}}</span>
                </p>
                <p>
                  <span>联系电话：</span>
                  <span>{{fillingDeta.phone}}</span>
                </p>
                <p>
                  <span>注册地址：</span>
                  <span>{{fillingDeta.provinceName}} {{fillingDeta.cityName}} {{fillingDeta.countyName}} {{fillingDeta.address}}</span>
                </p>
                <p v-show="fillingDeta.zone">
                  <span>所属工业园区：</span>
                  <span>{{formatZone(fillingDeta.zone)}}</span>
                </p>
                <p>
                  <span>所属区划类型</span>
                  <span>{{formatRegionType(fillingDeta.regionType)}}</span>
                </p>
                <p>
                  <span>所属区划：</span>
                  <span v-html='getRegions(fillingDeta.regions)'></span>
                </p>
                <div v-if="fillingDeta.subjectType == 0 && fillingDeta.delegated == true">
                  <p>
                    <span>编制单位名称：</span>
                    <span>{{fillingDeta.delegateOrgName}}</span>
                  </p>
                  <p>
                    <span>编制单位地址：</span>
                    <span>{{fillingDeta.delegateOrgAddr}}</span>
                  </p>
                  <p>
                    <span>编制单位联系人：</span>
                    <span>{{fillingDeta.delegateOrgLinkMan}}</span>
                  </p>
                  <p>
                    <span>编制单位联系电话：</span>
                    <span>{{fillingDeta.delegateOrgPhone}}</span>
                  </p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="预案概要" name="four">
                <numde></numde>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="box" v-if='fillingDeta.subjectType === 1'>
      <el-row>
        <el-col :span="3">
          <div class="box-t-l">
            <p>文件列表</p>
            <ul class="ull">
              <li v-for='(m, index) in fillingDeta.plandoc' :key="index" @click="getfile(m,index)" :class='{activess:activeli === index}'>
                <span slot="label">
                  {{formatPlanDoc(m.type)}}</span>
              </li>
            </ul>
          </div>
        </el-col>
        <el-col :span="14">
          <div class="box-pdf box-t-r">
            <pdf :src="srcaddress" :activeData="activeData" :canReupload="false"></pdf>
          </div>
        </el-col>
        <el-col :span="7">
          <div class="box-t-rb">
            <el-tabs v-model="activeName2" type="card">
              <!-- <el-tab-pane label="备案信息" name="first">
                <p class="title">
                  <span>备案流水号： {{fillingDeta.serialCode}}</span>
                </p>
              </el-tab-pane> -->
              <el-tab-pane label="申报单位信息" name="second">
                <p>
                  <span>企业全称：</span>
                  <span>{{fillingDeta.subjectName}}</span>
                </p>
                <p>
                  <span>中心坐标：</span>
                  <span>东经：{{fillingDeta.longitude | formatDegree}}，北纬：{{fillingDeta.latitude | formatDegree}}</span>
                </p>
                <p>
                  <span>单位地址：</span>
                  <span>{{fillingDeta.address}}</span>
                </p>
                <p>
                  <span>所属区划：</span>
                  <span>{{getRegions(fillingDeta.regions)}}</span>
                </p>
                <p>
                  <span>联系人：</span>
                  <span>{{fillingDeta.linkMan}}</span>
                </p>
                <p>
                  <span>联系电话：</span>
                  <span>{{fillingDeta.phone}}</span>
                </p>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="营业执照" v-model="dialogVisible" size="tiny">
      <img :src='imageSrc' width="100%" />
    </el-dialog>
  </div>
</template>
<script>
import fillingInfo from "./../../data/basic/weather/filling";
// import pdf from "./../../components/general/pdft.vue";
import pdf from './../../components/general/pdfNew.vue';
import numde from "./../../components/weather/numberinfo.vue";
import weather from "./../../data/emer/weather.js";
export default {
    components: {
        pdf,
        numde
    },
    data() {
        return {
            activeName2: "second",
            valdata: "",
            activeli: 0,
            datalist: "",
            // 文件地址
            srcaddress: "",
            // 文件上传
            fileLength: "",
            defaultOption: {},
            none_box: false,
            dialogVisible: false,
            imgshow: 1,
            planId: "",
            fillingDeta: {},
            imageSrc: "",
            photo:[],
            tableData: [
                {
                    date: "III级",
                    name: "10",
                    address: "13"
                },
                {
                    date: "II级",
                    name: "10",
                    address: "13"
                },
                {
                    date: "I级",
                    name: "10",
                    address: "13"
                }
            ],
            measureStateName: [
                {
                    value: "SO2",
                    label: "二氧化硫"
                },
                {
                    value: "Dust",
                    label: "烟、粉尘"
                },
                {
                    value: "NOx",
                    label: "氮氧化物"
                },
                {
                    value: "VOCs",
                    label: "VOCs(挥发性有机物质)"
                }
            ],
            box_state: false,
            typeState: false,
            // 选中的数据
            activeData: {
                id: "",
                type: 1,
                value: ""
            }
        };
    },
    watch: {
        fillingDeta() {
            if (this.fillingDeta.plandoc.length < 1) {
                return;
            } else {
                this.activeData.id = this.fillingDeta.plandoc[this.activeli].id;
            }
        }
    },
    created() {
        this.planId = sessionStorage.planIdLists;
        this.getDetail({
            planId: this.planId,
            subjectType: 0
        });
        if (!this.planId) return;
        this.fillingInfo({
            planId: this.planId
        });
        if (!sessionStorage.BoxState) return;
        this.box_state = JSON.parse(sessionStorage.BoxState);
    },
    methods: {
        ChangeName(val) {
            return val == null ? "未选择行业" : val.name;
        },
        fillingInfo(data) {
            (async () => {
                try {
                    let planInfo = await fillingInfo.get_fillingInfo(data);
                    if (planInfo.status) {
                        this.fillingDeta = planInfo.data;
                        this.previewImg(this.fillingDeta.imgName)
                        if (this.fillingDeta.plandoc.length && this.fillingDeta.plandoc[0].id) {
                            this.srcaddress = `/api/emer/plandoc/download?id=${
                                this.fillingDeta.plandoc[0].id
                            }&isOnline=true`;
                        }
                        this.fillingDeta.plandoc.length > 0
                            ? (this.fileLength = false)
                            : (this.fileLength = true);
                    }
                    if (
                        this.fillingDeta.subjectType === 0 &&
                        this.fillingDeta.plandoc.length === 4
                    ) {
                        this.typeState = true;
                        this.box_state = true;
                    }
                    if (
                        this.fillingDeta.subjectType === 1 &&
                        this.fillingDeta.plandoc.length >= 3
                    ) {
                        this.typeState = true;
                        this.box_state = true;
                    }
                    this.none_box = true;
                } catch (err) {
                    console.log(err);
                }
            })();
        },
        // 详情
        getDetail(params) {
            (async () => {
                try {
                    let info = await weather.subject_detail(params);
                } catch (error) {
                    this.$message.error("网络异常，请稍后重试");
                }
            })();
        },
        previewImg(src, type, id) {
            let TOKEN = sessionStorage.getItem('publicToken')
            if (type) {
              if(id){
                this.imageSrc = `/api/emer/plandoc/download?id=${id}&isOnline=true`;
                this.photo[0] = this.imageSrc
              }
            } else {
                if (src) {
                  let arr = src.replace(/^;/,'').replace(/;$/,'').split(';')
                  if (arr.length == 1 && arr != '' && arr[0]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[0]}&AccessToken=${TOKEN}`
                      this.photo[0] = this.imageSrc
                  } else if (arr.length > 1 && arr[1]) {
                      this.imageSrc = `/api/basic/img/get?name=${arr[1]}&AccessToken=${TOKEN}`
                      this.photo[0] = this.imageSrc
                  } else {
                    this.imageSrc =  './../../../static/img/000.png'
                    this.photo[0] = this.imageSrc
                  }
                }else{
                    this.imageSrc =  './../../../static/img/000.png'
                    this.photo[0] = this.imageSrc
                }
            }
            // this.dialogVisible = true;
        },
        formatZone(zone) {
            if (!zone) return "无所属工业园区";
            return zone.name;
        },
        formatEaer(zone) {
            if (!zone) return "";
            return `${zone.provinceName},${zone.cityName},${zone.countyName}`;
        },
        formatRegionType(regionType) {
            let regionName = "";
            switch (regionType) {
                case 1:
                    regionName = "单个区县";
                    break;
                case 2:
                    regionName = "跨区县";
                    break;
                case 3:
                    regionName = "跨市";
                    break;
            }
            return regionName;
        },
        formatKeyPollutants(keyname) {
            let keyPollutants = "";
            let keyArr = [];
            if (!keyname) return;
            if (keyname.indexOf(",") !== -1) {
                keyArr = keyname.split(",");
            } else {
                keyArr.push(keyname);
            }
            for (let i = 0; i < keyArr.length; i++) {
                for (let k = 0; k < this.measureStateName.length; k++) {
                    if (keyArr[i] === this.measureStateName[k].value) {
                        keyPollutants += this.measureStateName[k].label + "，";
                    }
                }
            }
            return keyPollutants.substring(0, keyPollutants.length - 1);
        },
        downloadFiles(id) {
            if(id){
                window.location.href = `/api/emer/plandoc/download?id=${id}&isOnline=false`;
            }
        },
        getRegions(regions) {
            if (!regions) return;
            let regionsName = "";
            for (let i = 0; i < regions.length; i++) {
                regionsName +=
                    regions[i].province.name + "," + regions[i].city.name + ",";
                for (let k = 0; k < regions[i].county.length; k++) {
                    if (regions[i].county[k].name) {
                        regionsName += regions[i].county[k].name + ",";
                    }
                }
            }
            return regionsName.substring(0, regionsName.length - 1);
        },
        formatPlanDoc(num, filename) {
        let docName = ''
        switch (num) {
            case 1:
            docName = '备案表'
            break
            case 2:
            docName = '应急预案'
            break
            case 3:
            docName = '风险评估报告'
            break
            case 4:
            docName = '应急资源调查报告'
            break
            case 5:
            docName = '专家评审意见书'
            break
            case 6:
            docName = '补充其他（平面图等）'
            break
            case 7:
            docName = '审查意见书'
            break
            case 8:
            docName = '编制说明'
            break
            case 51:
            docName = '备案表'
            break
            case 52:
            docName = '应急预案'
            break
            case 53:
            docName = '专家评审意见书'
            break
            case 54:
            docName = '应急响应减排措施及现场核查表'
            break
            case 55:
            docName = '审查意见书'
            break
            case 98:
            docName = '其他 '
            break
            case 99:
            docName = '其他 '
            break
            default:
            docName = "其他 ";
            break;
        }
        return docName
        },
        //
        showImg(id, filename) {
            let file_name = /\.[^\.]+/.exec(filename);
            if (file_name[0] == ".png" || file_name[0] == ".jpg") {
                return `/api/emer/plandoc/download?id=${id}&isOnline=true`;
            }
        },
        formatIndustryType(val) {
            let industryType = ''
            switch (val) {
                case 1:
                industryType = '钢铁-G'
                break
                case 2:
                industryType = '焦化-J'
                break
                case 3:
                industryType = '水泥-S'
                break
                case 4:
                industryType = '玻璃-B'
                break
                case 5:
                industryType = '医药-Y'
                break
                case 6:
                industryType = '化工-H'
                break
                case 7:
                industryType = '危险废物处置(利用)-W'
                break
                case 8:
                industryType = '铸造-ZZ'
                break
                case 9:
                industryType = '火电-HD'
                break
                case 10:
                industryType = '涉Voc（除医药、化工）-V'
                break
                case 11:
                industryType = '建材（除水泥）-JC'
                break
                case 12:
                industryType = '高架源-GJ'
                break
                case 13:
                industryType = '碳素（包括炭黑）-TS'
                break
                case 99:
                industryType = '其他-Q'
                break
            }
            return industryType
        },
        // 改变签章地址
        changeSignatureUrl(id) {
            if(id){
                window.location.href = `/api/emer/plandoc/download?id=${id}&isOnline=false`;
            }
        },
        // 文件下载
        getfile(val, index) {
            this.activeData = val;
            this.activeli = index;
            if (!val.id) return;
            this.srcaddress = `/api/emer/plandoc/download?id=${
                val.id
            }&isOnline=true`;
        }
    }
};
</script>
<style lang="stylus" scoped>
.box {
  box-sizing: border-box;
  height: 1000px;
  margin: 0 auto;
  overflow: hidden;
}

.box-pdf {
  border: solid 1px #d1dbe5;
  height: 600px;
}

.box-t-l {
  width: 200px;
  display: inline-block;
  overflow: hidden;
  box-sizing: border-box;

  ul li {
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid transparent;
    text-align: left;
    padding: 10px;

    span {
      font-size: 14px;
    }
  }
}

.box-t-rb {
  padding-left: 10px;

  p {
    padding-left: 10px;
    line-height: 35px;

    span {
      font-size: 14px;
    }
  }
}

.activess {
  color: #409eff;
  display: inline-block;
  width: 200px;
  border-left: solid 2px #409eff !important;
}

.box-b {
  padding: 10px;
  height: 100px;

  p {
    margin-top: 15px;
  }
}

.errTips {
  color: red;
}

.a-hover {
  color: #409eff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.head-title {
  border-bottom: none !important;
}

.flex {
    display: flex;
    flex-wrap: wrap;
}

.flex-vc {
    align-items: center;
}

.flex-hs {
    justify-content: flex-start;
}

.seeBigImg {
  width:80px;
  img {
    width:100%;
  }
}
</style>



// WEBPACK FOOTER //
// filingBefore.vue?66cfe201